import React, { useState } from 'react';
import { HelpCircle } from 'lucide-react';

const MetricCard = ({ label, value, unit, description }) => {
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <div
      className="bg-slate-50 rounded-lg p-2 relative"
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
    >
      <div className="flex items-center justify-between mb-1">
        <div className="text-xs text-slate-500">{label}</div>
        <HelpCircle className="w-3 h-3 text-slate-400" />
      </div>
      <div className="flex items-baseline gap-1">
        <span className="text-xl font-bold text-slate-900">
          {value}
        </span>
        <span className="text-xs text-slate-500">{unit}</span>
      </div>

      {/* Tooltip */}
      {showTooltip && (
        <div className="absolute z-50 bottom-full left-1/2 -translate-x-1/2 mb-2 w-64 pointer-events-none">
          <div className="bg-slate-900 text-white text-xs rounded-lg p-3 shadow-xl">
            <div className="font-semibold mb-1">{label}</div>
            <div className="text-slate-300 leading-relaxed">{description}</div>
            {/* Arrow */}
            <div className="absolute top-full left-1/2 -translate-x-1/2 -mt-px">
              <div className="border-8 border-transparent border-t-slate-900"></div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MetricCard;
